<template>
    <div class="kfc_start fc ac">
        <div v-if="!isCloseKfc" class="kfc_content fc ac jsb">
            <div class="fc ac">
                <img
                    class="logo"
                    src="https://res.dumovie.com/slide/202005/1590732034976.png"
                    alt
                />
                <span class="time">（点餐时间 10:30 至 21:00）</span>
            </div>
            <div class="types fc ac">
                <img
                    @click="selectType('dineIn')"
                    :src="
                        kfcType == 'dineIn'
                            ? 'https://res.dumovie.com/slide/202005/1590733712783.png'
                            : 'https://res.dumovie.com/slide/202005/1590732519987.png'
                    "
                    alt
                />
                <img
                    @click="selectType('delivery')"
                    :src="
                        kfcType == 'delivery'
                            ? 'https://res.dumovie.com/slide/202005/1590733533719.png'
                            : 'https://res.dumovie.com/slide/202005/1590732803684.png'
                    "
                    alt
                />
            </div>
            <kfc-tab-bar></kfc-tab-bar>
        </div>
        <div v-else class="announcement fc ac">
            <img :src="imgBaseUrl + kfcAnnouncePath" alt="">
        </div>
    </div>
</template>

<script>
import { Indicator, MessageBox, Toast } from "mint-ui";
import kfcTabBar from "../../components/common/kfcTabBar.vue";
export default {
    data() {
        return {
            imgBaseUrl: this.$global.imgBaseUrl,
            kfcType: "",
            selectedKfcType: this.getLocal("selectedKfcType")
                ? this.getLocal("selectedKfcType")
                : "",
            openid: this.getLocal("openid") ? this.getLocal("openid") : "", //微信openid
            code: sessionStorage.getItem("code")
                ? sessionStorage.getItem("code")
                : "", //获取微信openid需要的code
            isCloseKfc: false,
            kfcAnnouncePath: "",
        };
    },
    watch: {
        selectedKfcType: function (newVal, oldVal) {
            if (newVal && oldVal && newVal != oldVal) {
                this.removeLocal("cartArr");
            }
        },
    },
    components: {
        kfcTabBar,
    },
    created() {
        this.getStatus();
        let ua = navigator.userAgent.toLowerCase();
        console.log(ua);
        if (this.code && !this.openid) {
            this.getOpenId();
        }
    },
    methods: {
        // 获取是否关闭星巴克功能的状态
        getStatus() {
            this.$post({
                method: "meishi.open.cfg",
            }).then((res) => {
                if (res.success && res.data.length) {
                    for (let i of res.data) {
                        if (i.category == "kfc") {
                            this.isCloseKfc = i.status == "close" ? true : false;
                            this.kfcAnnouncePath = i.img;
                        }
                    }
                }
            });
        },
        // 获取微信openid
        getOpenId() {
            this.$post({
                method: "weixin.get.openid",
                code: this.code,
            }).then((res) => {
                if (res.success) {
                    this.openid = res.data;
                    this.setLocal("openid", res.data);
                }
            });
        },
        selectType(type) {
            // 微信环境需要openid
            let ua = navigator.userAgent.toLowerCase();
            let isWeixin = ua.indexOf("micromessenger") != -1 ? true : false;
            if (isWeixin && !this.openid) {
                let domain =
                    window.location.protocol + "//" + window.location.host; // 域名
                const url = encodeURI(
                    domain + "/duwap/static/getCode/getCode.html?usertype=kfc"
                );
                // const url = encodeURI(
                //     domain +  "/duwap/static/getCode/getCode.html"
                // );

                // const url = encodeURI(
                //     "https://wap.dumovie.com/duwap/static/getCode/getCode.html"
                // );
                window.location.href = url;
                return;
            }
            this.kfcType = type;
            this.setLocal(
                "selectedKfcType",
                type == "dineIn" ? "zizhu" : "waisong"
            );
            this.selectedKfcType = type == "dineIn" ? "zizhu" : "waisong";
            this.$nextTick(() => {
                setTimeout(() => {
                    this.enterKFC(type);
                }, 400);
            });
        },
        enterKFC(type) {
            switch (type) {
                case "dineIn":
                    // this.$router.push({
                    //     path: "/kfcSelectDiner",
                    //     query: { disttype: "zizhu" }
                    // });
                    MessageBox.confirm(
                        "点餐为第三方提供服务，取餐码收取可能会有延迟。当你支付后，请凭取餐码等候门店屏幕的显示后即可取餐。一切商业行为与肯德基无关，如有疑问请联系客服。"
                    )
                        .then((action) => {
                            if (action == "confirm") {
                                this.$router.push({
                                    path: "/kfcSelectDiner",
                                    query: { disttype: "zizhu" },
                                });
                            }
                        })
                        .catch((err) => {
                            this.kfcType = "";
                            console.log(err);
                        });
                    break;
                case "delivery":
                    // this.$router.push({
                    //     path: "/kfcMenu",
                    //     query: { disttype: "waisong" },
                    // });
                    MessageBox.confirm(
                        "本外卖为第三方提供服务，配送可能会有延迟。一切商业行为与肯德基无关。为了更好的体验，会自动选择距离最近的门店。线上门店信息、地址仅供参考，如有疑问请联系客服。"
                    )
                        .then((action) => {
                            if (action == "confirm") {
                                this.$router.push({
                                    path: "/kfcMenu",
                                    query: { disttype: "waisong" },
                                });
                            }
                        })
                        .catch((err) => {
                            this.kfcType = "";
                            console.log(err);
                        });
                    break;
            }
        },
    },
};
</script>
<style scoped lang="scss">
.kfc_start {
    width: 100%;
    .kfc_content {
        width: 100%;
        height: 100%;
        background: #fff;
        position: fixed;
        top: 0;
        .logo {
            width: 518px;
            height: 522px;
            margin-top: 20px;
        }
        .time {
            font-size: 24px;
            color: #ce000c;
            margin-top: 10px;
        }
        .types {
            margin-bottom: 170px;
            img {
                width: 610px;
                height: 160px;
                margin-top: 40px;
            }
        }
    }
    .announcement {
        width: 100%;
        min-height: 100vh;
        background: #fff;
        img {
            width: 100%;
        }
    }
}
.mint-msgbox-wrapper {
    .mint-msgbox {
        font-size: 28px !important;
        border-radius: 10px;
        .mint-msgbox-header {
            padding-top: 30px;
            .mint-msgbox-title {
                font-size: 30px !important;
            }
        }
        .mint-msgbox-content {
            padding: 30px;
        }
        .mint-msgbox-btns {
            height: 70px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/kfc/kfcIndex.vue